<template>


    <a-spin :spinning="confirmLoading">
      <div class="title">同步视图</div>
      <div class="form">
      <a-form :form="form" >
        <a-row type="flex" justify="center" align="top">
        <a-col :md="24" :lg="8">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="源数据源">
          <j-dict-select-tag placeholder="请选择源数据源" dict-code="sys_data_source,code,name" triggerChange v-decorator="['from', validatorRules.from]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="目标数据源">
          <j-dict-select-tag placeholder="请选择目标数据源" dict-code="sys_data_source,code,name" triggerChange v-decorator="['to', validatorRules.to]"/>
        </a-form-item>

        <a-form-item
        :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          style="text-align:center"
        >
            <a-button type="primary" @click="handleOk">提交</a-button>
          </a-form-item>
        </a-col>
         </a-row>
      </a-form>
      </div>
    </a-spin>
</template>

<script>
  import pick from 'lodash.pick'
  import { httpAction, postAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'SysDataSourceModal',
    components: {},
    data() {
      return {
        title: '操作',
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules: {
          from: { rules: [{ required: true, message: '请选择源数据源!' }] },
          to: { rules: [{ required: true, message: '请选择目标数据源!' }] }
        },
        url: {
          add: '/sys/dataSource/syncView',
        },
      }
    },
    created() {
    },
    methods: {
      handleOk() {
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true
            let formData = Object.assign(this.model, values)
            let httpUrl = this.url.add, method = 'post'
            httpAction(httpUrl, formData, method).then((res) => {
              if (res.success) {
                this.$message.success(res.message)
                this.$emit('ok')
                this.close()
              } else {
                this.$message.warning(res.message)
              }
            }).finally(() => {
              this.confirmLoading = false
            })
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>
.title {
  text-align: center;
  margin: 20px;
  font-size: 30px;

}
.form {
  margin: 0 auto;
}
</style>